import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mediaquery: 0
  },
  mutations: {
    SET_MEDIAQUERY (state, payload) {
      state.mediaquery = payload
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})
